module.exports = __webpack_public_path__ + "img/logo-canoas-del-deva.0e280970.png";